import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormactionService } from '../../api/formaction.service';

@Component({
  selector: 'app-ericount',
  templateUrl: './ericount.component.html',
  styleUrls: ['./ericount.component.css']
})
export class EricountComponent implements OnInit {

  public eristatuslistcount: any = 1;
  public eristatusresolvecount: any = 0;
  public eristatuspendingcount: any = 0;
  public eristatusrejectcount: any = 0;
  public bdnustatuscount: any = 0;
  public pdustatusresolvecount: any = 0;
  public pdustatuspendingcount: any = 0;
  public pdustatusrejectcount: any = 0;

  public singletotalcount:number = 1;
  public singlependingcount:number = 1;
  public singleresolvecount:number = 1;
  public singlerejectcount:number = 1;

  public bulktotalcount:number = 1;
  public bulkpendingcount:number = 1;
  public bulkresolvecount:number = 1;
  public bulkrejectcount:number = 1;

  public dirnimitotalcount:number = 1;
  public dirnimipendingcount:number = 1;
  public dirnimiresolvecount:number = 1;
  public dirnimirejectcount:number = 1;


  public cricount: any = 0;
  public criresolvecount: any = 0;
  public cripendingcount: any = 0;
  public crirejectcount: any = 0;

  public shippedCount:any = 0;
  public ccverifycount:any = 0;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router, private formaction: FormactionService) { }

  ngOnInit(): void {
    // this.api.eriStatusListCount().subscribe((result: any) => {
    //   console.log(result[0]['count'])
    //   this.eristatuslistcount = result[0]['count'];
    // })
    // this.api.eristatusresolvecount().subscribe((result: any) => {
    //   console.log(result[0]['count'])
    //   this.eristatusresolvecount = result[0]['count'];
    // })
    // this.api.eristatuspendingcount().subscribe((result: any) => {
    //   console.log(result[0]['count'])
    //   this.eristatuspendingcount = result[0]['count'];
    // })
    // this.api.eristatusrejectcount().subscribe((result: any) => {
    //   console.log(result[0]['count'])
    //   this.eristatusrejectcount = result[0]['count'];
    // })
    this.api.bdnustatuscount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.bdnustatuscount = result[0]['count'];
    })



    this.api.singletotalcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.singletotalcount = result[0]['count'];
    })
    this.api.singlependingcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.singlependingcount = result[0]['count'];
    })
    this.api.singleresolvecount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.singleresolvecount = result[0]['count'];
    })
    this.api.singlerejectcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.singlerejectcount = result[0]['count'];
    })

    this.api.bulktotalcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.bulktotalcount = result[0]['count'];
    })
    this.api.bulkpendingcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.bulkpendingcount = result[0]['count'];
    })
    this.api.bulkresolvecount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.bulkresolvecount = result[0]['count'];
    })
    this.api.bulkrejectcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.bulkrejectcount = result[0]['count'];
    })

    this.api.dirnimitotalcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.dirnimitotalcount = result[0]['count'];
    })
    this.api.dirnimipendingcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.dirnimipendingcount = result[0]['count'];
    })
    this.api.dirnimiresolvecount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.dirnimiresolvecount = result[0]['count'];
    })
    this.api.dirnimirejectcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.dirnimirejectcount = result[0]['count'];
    })

    this.api.pdustatusresolvecount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.pdustatusresolvecount = result[0]['count'];
    })
    this.api.pdustatuspendingcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.pdustatuspendingcount = result[0]['count'];
    })
    this.api.pdustatusrejectcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.pdustatusrejectcount = result[0]['count'];
    })

    this.api.cristatuscount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.cricount = result[0]['count'];
    })

    this.api.criresolvecount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.criresolvecount = result[0]['count'];
    })
    this.api.cripendingcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.cripendingcount = result[0]['count'];
    })
    this.api.crirejectcount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.crirejectcount = result[0]['count'];
    })

    this.api.shipped_count().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.shippedCount = result[0]['count'];
    })

    this.api.ccverifycount().subscribe((result: any) => {
      console.log(result[0]['count'])
      this.ccverifycount = result[0]['count'];
    })


  }

}
